
const $ = window.jQuery;

export default class Utils {

  static removeTrailingSlash( path ) {
    return path.charAt(path.length - 1) === '/' ? path.substr(0, path.length-1) : path;
  }

  static addTrailingSlash( path ) {
    if( 
      typeof path === 'undefined' 
      || path.indexOf('#') !== -1 
      || path.indexOf('?') !== -1 ) {
      return path;
    }
    return path + (path.charAt(path.length - 1) === '/' ? '' : '/');
  }
  
  static getUrlLocation( url ) {
    var l = document.createElement("a");
    l.href = url;
    return l.host;
  }

  static isExternalUrl( url ) {
    
    return ( url.indexOf(':') > -1 && this.getUrlLocation( location.href ) !== this.getUrlLocation( url ) );
  }

  static elementIsUnderMouse( event, el ) {

    var 
      x = event.clientX,
      y = event.clientY;

    //special bonus for those using jQuery
    if (typeof $ === "function" && el instanceof $) {
      el = el[0];
    }
    var rect = el.getBoundingClientRect();

    return (
      rect.left <= x &&
      rect.top <= y &&
      rect.right >= x &&
      rect.bottom >= y
    );
  }

  static elementIsInViewport(el, threshold = 0) {

    //special bonus for those using jQuery
    if (typeof $ === "function" && el instanceof $) {
      el = el[0];
    }

    var rect = el.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;

    return (
        rect.top >= 0 + threshold &&
        rect.left >= 0 + threshold &&
        rect.bottom <= viewportHeight - threshold && /*or $(window).height() */
        rect.right <= viewportWidth - threshold /*or $(window).width() */
    );
  }

  static elementIsVisible( el, threshold = 0 ) {
    // special bonus for those using jQuery
    if (typeof $ === "function" && el instanceof $) {
      el = el[0];
    }
    var rect = el.getBoundingClientRect();
    var viewportHeight = $(window).height();
    var viewportWidth = $(window).width();

    return (
      rect.top < viewportHeight + threshold && 
      rect.bottom > - threshold &&
      rect.left < viewportWidth + threshold && 
      rect.right > - threshold
    );
  }

  static throttle( fn, threshhold, scope ) {
    threshhold || (threshhold = 250);
    var last,
        deferTimer;
    return function () {
      var context = scope || this;

      var now = +new Date,
          args = arguments;
      if (last && now < last + threshhold) {
        // hold on to it
        clearTimeout(deferTimer);
        deferTimer = setTimeout(function () {
          last = now;
          fn.apply(context, args);
        }, threshhold);
      } else {
        last = now;
        fn.apply(context, args);
      }
    };
  }

  static setPrefixedCss($el, property, value) {

    let nativeProperty = property.substr( 0, 1 ).toLowerCase() + property.substr( 1 );
    
    $el.each((i, el) => {
      el.style["webkit" + property] = value;
      el.style["Moz" + property] = value;
      el.style["ms" + property] = value;
      el.style["O" + property] = value;
      el.style[nativeProperty] = value;
    });

  }

  // http://stackoverflow.com/questions/2541481/get-average-color-of-image-via-javascript
  static getAverageRGB( imgEl ) {
    const defaultRGB = {r:0,g:0,b:0}; // for non-supporting envs
    const src = imgEl.getAttribute('src');
    
    if( src.indexOf(window.GLOBALS.homeUrl) === -1 ) return defaultRGB;
    
    var blockSize = 10, // only visit every 5 pixels
        canvas = document.createElement('canvas'),
        context = canvas.getContext && canvas.getContext('2d'),
        data, width, height,
        i = -4,
        length,
        rgb = {r:0, g:0, b:0},
        count = 0;

    if( !context ) return defaultRGB;

    height = canvas.height = imgEl.naturalHeight || imgEl.offsetHeight || imgEl.height;
    width = canvas.width = imgEl.naturalWidth || imgEl.offsetWidth || imgEl.width;

    context.drawImage(imgEl, 0, 0);

    try {
      data = context.getImageData(width/2, height-20, width/2, 20);
    } catch(e) {
      /* security error, img on diff domain */
      // console.log(e);
      return defaultRGB;
    }

    length = data.data.length;

    while ( (i += blockSize * 4) < length ) {
        ++ count;
        rgb.r += data.data[i];
        rgb.g += data.data[i+1];
        rgb.b += data.data[i+2];
    }

    rgb.r = Math.floor(rgb.r/count);
    rgb.g = Math.floor(rgb.g/count);
    rgb.b = Math.floor(rgb.b/count);

    return rgb;

  }

  // http://www.w3.org/TR/AERT#color-contrast
  static getColorBrightness( rgb ) {
    return Math.round(((parseInt(rgb.r) * 299) + (parseInt(rgb.g) * 587) + (parseInt(rgb.b) * 114)) /1000);  
  }

}


$.fn.closestToOffset = function(offset) {
    let el = null,
        elOffset,
        x = offset.left,
        y = offset.top,
        distance,
        dx,
        dy,
        minDistance;
    this.each(function() {
        let $t = $(this);
        let elOffset = $t.offset();
        let right = elOffset.left + $t.width();
        let bottom = elOffset.top + $t.height();

        if (
            x >= elOffset.left &&
            x <= right &&
            y >= elOffset.top &&
            y <= bottom
        ) {
            el = $t;
            return false;
        }

        let offsets = [
            [elOffset.left, elOffset.top],
            [right, elOffset.top],
            [elOffset.left, bottom],
            [right, bottom],
        ];
        for (let off in offsets) {
            dx = offsets[off][0] - x;
            dy = offsets[off][1] - y;
            distance = Math.sqrt(dx * dx + dy * dy);
            if (minDistance === undefined || distance < minDistance) {
                minDistance = distance;
                el = $t;
            }
        }
    });
    return el;
};
